/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { makeStyles } from 'utils/makeStylesAdapter';
import {
  Grid,
  Box,
  TextareaAutosize,
  Typography,
  IconButton,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableFooter,
  Tooltip,
  MenuItem,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  InputConsensus,
  ButtonConsensus,
  KeyboardDatePicker,
  ModalConfirm,
  CurrencyTextField,
} from 'components';
import { colors } from 'utils/colorsSteps';
import { Skeleton } from '@mui/material';
import { toast } from 'react-toastify';
import { formatDateToISO8601 } from 'utils/date-time.utils';
import CircularProgress from '@mui/material/CircularProgress';
import moment from 'moment';
import { PENALTY_KINDS } from 'constants/agreement/penaltyKinds';
import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import { useSelector } from 'react-redux';
import { useParameterKeys } from 'hooks/useParameterKeys';

const useStyles = makeStyles(theme => ({
  containerForm: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  container: {
    margin: theme.spacing(2, 0, 2, 0),
  },
  containerParcels: {
    padding: theme.spacing(2),
    backgroundColor: '#ececec',
    borderRadius: '0.7rem',
    margin: theme.spacing(0, 0.8, 1, 0.8),
  },
}));

const AttendanceOfJudgement = props => {
  const {
    setDisabledActionsPenaltyTable = {},
    selectedIndex = null,
    setSelectedIndex = {},
    judgement,
    setJudgement,
    description,
    setDescription,
    institutionType,
    institutionSelected,
    judicialDistrictId,
  } = props;
  const classes = useStyles();

  const { isMPDFT } = useParameterKeys();

  const parameters = useSelector(state => state.parameters);

  const [row, setRow] = useState(null);

  const [openDeleteParcelModalConfirm, setOpenDeleteParcelModalConfirm] = useState(false);
  const [parcelToDelete, setParcelToDelete] = useState(null);

  const initialValues = {
    firstAttendanceDate: null,
    penalty: PENALTY_KINDS.ATTENDANCE_OF_JUDGEMENT,
    description: isMPDFT ? null : '',
    descriptionLocal: isMPDFT ? '' : description,
    parcels: [],
    numberOfParcels: 1,
    periodicity: 'Mensal',
    attendanceQuantity: 0,
    totalValue: 0,
  };

  const periodicityOptions = [
    { value: 'Semanal', label: 'Semanal' },
    { value: 'Mensal', label: 'Mensal' },
    { value: 'Bimestral', label: 'Bimestral' },
    { value: 'Trimestral', label: 'Trimestral' },
    { value: 'Quadrimestral', label: 'Quadrimestral' },
    { value: 'Semestral', label: 'Semestral' },
  ];

  const [formState, setFormState] = useState({
    isValid: false,
    values: { ...initialValues },
    touched: {},
    errors: {},
  });

  const [isAddingParcel, setIsAddingParcel] = useState(false);
  const [newParcel, setNewParcel] = useState({
    firstAttendanceDate: null,
  });

  const handleToggleAddParcel = () => {
    setIsAddingParcel(!isAddingParcel);
    setNewParcel({ firstAttendanceDate: null });
  };

  const handleAddNewParcel = () => {
    const { firstAttendanceDate } = newParcel;

    if (!firstAttendanceDate) {
      return toast.warn('Insira a data');
    }

    let date = firstAttendanceDate && moment(firstAttendanceDate);

    const parcel = {
      date: date && formatDateToISO8601(date),
    };

    const updatedParcels = [...formState.values.parcels, parcel];

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        parcels: updatedParcels,
        attendanceQuantity: updatedParcels.length,
      },
    }));

    setIsAddingParcel(false);
  };

  const orderParcelsByDate = parcels => {
    return parcels.sort((a, b) => Date.parse(a.date) - Date.parse(b.date));
  };

  useEffect(() => {
    setFormState(formState => ({
      ...formState,
      values:
        selectedIndex !== null
          ? {
              ...judgement[selectedIndex.index],
              descriptionLocal: isMPDFT ? judgement[selectedIndex.index].description : description,
            }
          : { ...initialValues },
    }));
  }, [selectedIndex]);

  useEffect(() => {
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        descriptionLocal: description,
      },
    }));
  }, [description]);

  const handleChangeQuantity = event => {
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]: event.target.value,
      },
    }));
  };

  const handleInputKeyPress = event => {
    if (event.key === ',' || event.key === '.') {
      event.preventDefault();
    }
  };

  const handleChange = event => {
    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        [event.target.name]:
          event.target.type === 'checkbox' ? event.target.checked : event.target.value,
      },
      touched: {
        ...formState.touched,
        [event.target.name]: true,
      },
    }));
    if (event.target.name === 'descriptionLocal') {
      setFormState(formState => ({
        ...formState,
        values: {
          ...formState.values,
          description: event.target.value,
        },
      }));
    }
  };

  const handleClearFormStat = () => {
    setRow(null);
    if (selectedIndex !== null) {
      setDisabledActionsPenaltyTable(prevState => ({
        ...prevState,
        [selectedIndex.penaltiesIndex]: { ...prevState[selectedIndex.penaltiesIndex], edit: false },
      }));
      setSelectedIndex(null);
    }
    setFormState(formState => ({
      ...formState,
      values: { ...initialValues },
    }));
    if (isMPDFT) {
      setFormState(formState => ({
        ...formState,
        values: {
          ...initialValues,
          description: '',
        },
      }));
    }
  };

  useEffect(() => {
    if (row) {
      setFormState(formState => ({
        ...formState,
        values: { ...row, descriptionLocal: isMPDFT ? row.description : description },
      }));
    }
  }, [row, institutionSelected]);

  const handleSubmit = event => {
    event.preventDefault();
    const { firstAttendanceDate, descriptionLocal, parcels } = formState.values;

    if (parcels.length === 0) {
      toast.warn('É necessário adicionar ao menos um comparecimento');
      return;
    }

    if (parcels.some(parcel => !parcel.date)) {
      toast.warn('Informe o campo de data em todas as parcelas');
      return;
    }

    if (!isMPDFT && descriptionLocal === '') {
      toast.warn('O campo observação é obrigatório');
    }

    const totalAttendances = parcels.length;

    if (selectedIndex !== null) {
      if (
        firstAttendanceDate &&
        judgement.find(
          (value, idx) =>
            value.firstAttendanceDate === firstAttendanceDate && idx !== selectedIndex.index,
        )
      ) {
        toast.warn('Data e quantidade de comparecimentos já inseridos');
        return;
      }

      let newArray = [...judgement];

      const firstDate =
        firstAttendanceDate || (parcels && parcels.length > 0 ? parcels[0].date : null);

      let newJudgement = {
        ...formState.values,
        attendanceQuantity: totalAttendances,
        penalty: PENALTY_KINDS.ATTENDANCE_OF_JUDGEMENT,
        firstAttendanceDate: firstDate,
      };
      setDescription(newJudgement.descriptionLocal);
      delete newJudgement.descriptionLocal;
      newArray[selectedIndex.index] = newJudgement;
      setJudgement(newArray);
    } else {
      if (
        firstAttendanceDate &&
        judgement.find(value => value.firstAttendanceDate === firstAttendanceDate)
      ) {
        toast.warn('Data e quantidade de comparecimentos já inseridos');
        return;
      }
      const firstDate =
        firstAttendanceDate || (parcels && parcels.length > 0 ? parcels[0].date : null);

      let newJudgement = {
        ...formState.values,
        attendanceQuantity: totalAttendances,
        penalty: PENALTY_KINDS.ATTENDANCE_OF_JUDGEMENT,
        firstAttendanceDate: firstDate,
      };
      setDescription(newJudgement.descriptionLocal);
      delete newJudgement.descriptionLocal;
      setJudgement([...judgement, newJudgement]);
    }

    handleClearFormStat();
  };

  const handleAddParcel = () => {
    const { firstAttendanceDate, numberOfParcels, periodicity } = formState.values;

    if (!firstAttendanceDate) {
      toast.warn('Selecione a data do primeiro comparecimento');
      return;
    }
    if (!numberOfParcels || numberOfParcels <= 0) {
      toast.warn('Insira a quantidade de comparecimentos');
      return;
    }
    if (!periodicity) {
      toast.warn('Selecione uma periodicidade');
      return;
    }

    const newParcels = [];
    let date = firstAttendanceDate && moment(firstAttendanceDate);

    let periodToAdd;
    let periodUnit;
    switch (periodicity) {
      case 'Semanal':
        periodToAdd = 1;
        periodUnit = 'weeks';
        break;
      case 'Mensal':
        periodToAdd = 1;
        periodUnit = 'months';
        break;
      case 'Bimestral':
        periodToAdd = 2;
        periodUnit = 'months';
        break;
      case 'Trimestral':
        periodToAdd = 3;
        periodUnit = 'months';
        break;
      case 'Quadrimestral':
        periodToAdd = 4;
        periodUnit = 'months';
        break;
      case 'Semestral':
        periodToAdd = 6;
        periodUnit = 'months';
        break;
    }

    if (!date) {
      toast.warn('É necessário definir uma data válida para o primeiro comparecimento');
      return;
    }
    for (let i = 0; i < numberOfParcels; i++) {
      newParcels.push({
        date: formatDateToISO8601(date.clone().add(i * periodToAdd, periodUnit)),
      });
    }

    const totalAttendances = parseInt(numberOfParcels, 10);

    setFormState(formState => ({
      ...formState,
      values: {
        ...formState.values,
        parcels: newParcels,
        attendanceQuantity: totalAttendances,
      },
    }));
  };

  const handleParcelDateChange = (index, newDate) => {
    const updatedParcels = formState.values.parcels.map((parcel, idx) =>
      idx === index ? { date: newDate } : parcel,
    );
    setFormState({
      ...formState,
      values: {
        ...formState.values,
        parcels: updatedParcels,
        attendanceQuantity: updatedParcels.length,
      },
    });
  };

  const handleOpenDeleteParcelModalConfirm = parcel => {
    setOpenDeleteParcelModalConfirm(true);
    setParcelToDelete(parcel);
  };

  const handleCloseDeleteParcelModalConfirm = () => {
    setOpenDeleteParcelModalConfirm(false);
    setParcelToDelete(null);
  };

  const deleteParcel = () => {
    const parcel = parcelToDelete;
    const index = formState.values.parcels.findIndex(item => item.date === parcel.date);
    if (index !== -1) {
      const newParcels = formState.values.parcels.filter(
        (value, _index, _arr) => value.date !== parcel.date,
      );
      setFormState(formState => ({
        ...formState,
        values: {
          ...formState.values,
          parcels: newParcels,
          attendanceQuantity: newParcels.length,
        },
      }));
    }
  };

  const handleToRead = () => {
    handleClearFormStat();
  };

  return (
    <Box className={classes.container}>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2} className={classes.containerForm}>
          <Grid
            container
            spacing={2}
            className={classes.containerParcels}
            size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
              <Box display="flex" alignItems="center" justifyContent="space-between">
                <Typography align="left" variant="h5" className={classes.form}>
                  Parcelas
                </Typography>
                {formState.values.parcels.length > 0 && isMPDFT && !isAddingParcel && (
                  <Tooltip title="Adicionar parcela" arrow placement="top">
                    <IconButton onClick={handleToggleAddParcel}>
                      <AddIcon style={{ color: colors.primary }} />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </Grid>

            {isAddingParcel && (
              <>
                <Grid size={{ xl: 3, lg: 3, md: 3, sm: 3, xs: 12 }}>
                  <KeyboardDatePicker
                    variant="inline"
                    name="newParcelDate"
                    label="Data"
                    value={newParcel.firstAttendanceDate || null}
                    onChange={newDate =>
                      setNewParcel({
                        ...newParcel,
                        firstAttendanceDate: newDate,
                      })
                    }
                  />
                </Grid>
                <Grid size={{ xl: 4, lg: 4, md: 4, sm: 4, xs: 12 }}></Grid>
                <Grid
                  style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '30px' }}
                  size={{ xl: 2, lg: 2, md: 2, sm: 2, xs: 12 }}>
                  <Tooltip title="Adicionar parcela" arrow placement="top">
                    <IconButton onClick={handleAddNewParcel}>
                      <AddIcon style={{ color: colors.primary }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Cancelar" arrow placement="top">
                    <IconButton onClick={handleToggleAddParcel} color="secondary">
                      <ClearIcon style={{ color: '#e1296a' }} />
                    </IconButton>
                  </Tooltip>
                </Grid>
              </>
            )}

            {formState.values.parcels.length === 0 && (
              <>
                <Grid size={{ xl: 4, lg: 4, md: 4, sm: 4, xs: 12 }}>
                  <KeyboardDatePicker
                    variant="inline"
                    name="firstAttendanceDate"
                    label="Data do primeiro comparecimento*"
                    value={formState.values.firstAttendanceDate || null}
                    onChange={newDate =>
                      setFormState(formState => ({
                        ...formState,
                        values: {
                          ...formState.values,
                          firstAttendanceDate: newDate,
                        },
                      }))
                    }
                  />
                </Grid>
                <Grid size={{ xl: 4, lg: 4, md: 4, sm: 4, xs: 12 }}>
                  <InputConsensus
                    label="Periodicidade*"
                    name="periodicity"
                    variant="standard"
                    onChange={handleChange}
                    value={formState.values.periodicity || ''}
                    fullWidth
                    select
                  >
                    {periodicityOptions.map(option => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </InputConsensus>
                </Grid>
                <Grid size={{ xl: 4, lg: 4, md: 4, sm: 4, xs: 12 }}>
                  <InputConsensus
                    label="Quantidade de comparecimentos*"
                    name="numberOfParcels"
                    variant="standard"
                    type="number"
                    inputProps={{
                      min: 1,
                    }}
                    onChange={handleChange}
                    onKeyPress={handleInputKeyPress}
                    value={formState.values.numberOfParcels || 1}
                    fullWidth
                  />
                </Grid>
                <Grid
                  style={{ display: 'flex', justifyContent: 'flex-end' }}
                  size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
                  <ButtonConsensus
                    title="Gerar Parcelas"
                    backgroundColor={colors.primary}
                    hovercolor={colors.primary}
                    onClick={() => handleAddParcel()}
                    size="medium"
                  />
                </Grid>
              </>
            )}
          </Grid>
          <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <TableContainer component={Paper}>
              <Table className={classes.table} size="small" aria-label="a dense table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Data do Comparecimento</TableCell>
                    <TableCell align="center" width={150}>
                      <Box display="flex" position="relative" justifyContent="center">
                        Ações
                      </Box>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {orderParcelsByDate(formState.values.parcels).map((item, index) => (
                    <TableRow key={index} hover>
                      <TableCell component="th" scope="row" align="center">
                        <KeyboardDatePicker
                          variant="inline"
                          name="firstAttendanceDate"
                          value={item.date || null}
                          onChange={newDate => handleParcelDateChange(index, newDate)}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <IconButton
                          color="primary"
                          size="small"
                          onClick={() => handleOpenDeleteParcelModalConfirm(item)}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TableCell align="left" colSpan={2} style={{ fontWeight: 'bold' }}>
                      Total de Comparecimentos: {formState.values.parcels.length}
                      <input
                        type="hidden"
                        name="attendanceQuantity"
                        value={formState.values.parcels.length}
                      />
                    </TableCell>
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          </Grid>
          <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <TextareaAutosize
              style={{ width: '100%', padding: 5, resize: 'none' }}
              maxRows={4}
              minRows={4}
              aria-label="maximum height"
              placeholder={`Observação${!isMPDFT ? '*' : ''}`}
              onChange={handleChange}
              name="descriptionLocal"
              value={isMPDFT ? formState.values.description : formState.values.descriptionLocal}
            />
          </Grid>
          <Grid
            style={{ display: 'flex', justifyContent: 'flex-end' }}
            size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }}>
            <ButtonConsensus
              title={`${selectedIndex !== null ? 'Alterar' : 'Incluir'} ${
                isMPDFT ? 'Medida' : 'Penalidade'
              }`}
              backgroundColor={colors.primary}
              hovercolor={colors.primary}
              type="submit"
              size="medium"
            />
            <ButtonConsensus
              title={`${selectedIndex !== null ? 'Cancelar' : 'Limpar'}`}
              backgroundColor={colors.primary}
              hovercolor={colors.primary}
              onClick={() => handleToRead()}
              size="medium"
              style={{ marginLeft: '-6px' }}
            />
          </Grid>
        </Grid>
      </form>
      {openDeleteParcelModalConfirm && (
        <ModalConfirm
          open={openDeleteParcelModalConfirm}
          handleClose={handleCloseDeleteParcelModalConfirm}
          onClick={deleteParcel}
          title="Excluir parcela"
        />
      )}
    </Box>
  );
};

export default AttendanceOfJudgement;
